import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDropTarget } from "source/app/services/Shared/Hooks/useDropTarget";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { UpdateDreamAsync } from "../../../LifeChangingEvents/UnderDevelopment/StacksContainer/Dreams/ShowName";
import { Sounds } from "source/app/services/Sound/Sounds";
const localStyles = require("../DreamRow.css");

export function DreamResonanceDropTarget({ dream }: { dream: IDream }) {
    const dropTargetResult = useDropTarget<IDream>(
        [EDragDropObject.dreamRow],
        ToggleDreamResonanceAsync
    );

    if (
        !dropTargetResult.isDragging ||
        dropTargetResult.draggedObject.id !== dream.id
    ) {
        return null;
    }

    return (
        <span
            ref={dropTargetResult.dropTargetRef}
            className={`${localStyles.dropTarget} ${localStyles.dropTargetToday}`}
            data-is-over={dropTargetResult.isOver}
        >
            <IconWithText
                iconSuffix={EGlyphicon["star"]}
                whenClicked={() => {}}
                displayAsBlock={false}
            >
                Today
            </IconWithText>
        </span>
    );
}

async function ToggleDreamResonanceAsync(dream: IDream) {
    return WithAnimatedProgressBarAsync(async () => {
        Sounds.shoutWhoo.Play();
        dream.isresonating = !dream.isresonating;
        await UpdateDreamAsync(dream);
    });
}
